import { HTMLReactParserOptions } from 'html-react-parser';
import { useEffect, useState } from 'react';
import { parseHtmlWithMathLatex } from '../../../../utils/htmlParser';

// Safe HTML Parser Component
interface SafeHtmlParserProps {
  html: string;
  onError: () => void;
  fallbackText?: string;
}

const SafeHtmlParser: React.FC<SafeHtmlParserProps> = ({
  html,
  onError,
  fallbackText = 'Error loading content',
}) => {
  const [hasError, setHasError] = useState(false);

  const [parsedContent, setParsedContent] = useState<React.ReactNode | null>(
    null
  );

  useEffect(() => {
    try {
      // Catch malformed nested opening tags like <b<span>, but allow
      // plain text comparisons such as "2 < 3".
      const malformedNestedTags = /<[A-Za-z][^>]*<[A-Za-z/][^>]*>/;

      if (malformedNestedTags.test(html)) {
        throw new Error('Malformed HTML: nested opening tags detected');
      }

      const parserOptions: HTMLReactParserOptions = {
        replace: (domNode) => {
          // Handle any problematic nodes by returning null
          if (domNode.type === 'tag' && domNode.name === 'script') {
            return null;
          }
          return undefined;
        },
      };

      const parsed = parseHtmlWithMathLatex(html, parserOptions);
      setParsedContent(parsed);
      setHasError(false);
    } catch (error) {
      console.error('Error parsing HTML:', error);
      setHasError(true);
      setParsedContent(null);
      onError();
    }
  }, [html, onError]);

  if (hasError) {
    return <div>{fallbackText}</div>;
  }

  return <>{parsedContent}</>;
};

export default SafeHtmlParser;
